import React, { Component } from 'react';
import Moment from 'moment';
import classes from './DeviceHistory.css';
import Tooltip from 'react-tooltip-lite';

export default class RSSIAlarmHistory extends Component {
  findTargetView = () => {
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      return 'Mobile';
    } else {
      return 'Desktop';
    }
  };

  prepareBarForMobile = (events) => {
    return events.map((tick, i) => {
      let divStyle = {
        position: 'relative',
        width: '25px',
        margin: '0px',
        fontSize: '1px',
      };
      if (tick.alarmColor) {
        divStyle['background-color'] = tick.alarmColor;
        divStyle['color'] = tick.alarmColor;
      }
      return (
        <div className="target" style={divStyle}>
          '
        </div>
      );
    });
  };

  prepareBarForDesktop = (events) => {
    return events.map((tick, i) => {
      return (
        <Tooltip
          key={i}
          styles={{
            backgroundColor: tick.alarmColor,
            width: 25,
            margin: 0,
            color: tick.alarmColor,
            fontSize: 1,
          }}
          content={
            <div style={{ backgroundColor: 'black', borderRadius: 5 }}>
              <p
                style={{
                  color: 'white',
                  textAlign: 'center',
                  fontSize: 12,
                  margin: 5,
                  padding: 0,
                }}
              >
                {Moment(tick.timestamp).format('MMM D, YYYY, h:mm:ss a')}
              </p>
              <p
                style={{
                  color: 'white',
                  textAlign: 'center',
                  fontSize: 12,
                  margin: 5,
                  padding: 0,
                }}
              >
                {tick.value === 0
                  ? 'Offline'
                  : tick.value < -70
                  ? 'Alarm'
                  : tick.value >= -70 && tick.value <= -65
                  ? 'Warning'
                  : 'Online'}
              </p>
            </div>
          }
          direction="up"
          tagName="div"
          className="target"
          arrow={false}
        >
          '
        </Tooltip>
      );
    });
  };

  render() {
    //console.log("RSSIAlarmHistory.render", new Date(), "props", this.props);
    let events = this.props.mappedRssi;

    let cols;
    if (events.length) {
      let targetView = this.findTargetView();
      //console.log("targetView RSSIAlarmHistory", targetView);
      if (targetView === 'Desktop') {
        cols = this.prepareBarForDesktop(events);
      } else {
        cols = this.prepareBarForMobile(events);
      }
    } else {
      cols = <div />;
    }
    //console.log("RSSIAlarmHistory.render started rendering", new Date());

    let content = (
      <div
        className={[classes.BodyRow, classes.BodyRow1].join(' ')}
        style={{ background: 'none' }}
      >
        <div className={classes.BodyTitle}> {this.props.title} </div>
        <div className={classes.BodyInfo}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row-reverse',
              flexWrap: 'nowrap',
              border: '1px solid lightgray',
              height: 25,
            }}
          >
            {cols}
          </div>
          <div className={classes.Row}>
            <div className={classes.Column}>
              {this.props.days === '1'
                ? Moment(Date.now() - 3600000 * 24).format('ddd h:mma')
                : Moment(Date.now() - 3600000 * 24 * 7).format('MMM D')}
            </div>
            <div className={classes.Column} style={{ textAlign: 'center' }}>
              {this.props.days === '1'
                ? Moment(Date.now() - 3600000 * 12).format('ddd h:mma')
                : Moment(Date.now() - 3600000 * 24 * 3.5).format('MMM D')}
            </div>
            <div className={classes.Column} style={{ textAlign: 'right' }}>
              {this.props.days === '1'
                ? Moment(Date.now()).format('ddd h:mma')
                : Moment(Date.now()).format('MMM D')}
            </div>
          </div>
        </div>
      </div>
    );
    //console.log("RSSIAlarmHistory.render completed rendering", new Date());
    return content;
  }
}
